export enum FormActionTypeEnum {
  PASWORD_CHANGE = 'passwordChange',
  INTL_BENEFICIARY_ADD = 'intlBeneficiaryAdd',
  KYC_DETAILS = 'kycDetails',
  KYB_DETAILS = 'kybDetails',
  CUSTOM_QUESTION = 'customQuestion',
  EXCHANGE_QUOTE_SUMMARY = 'exchangeQuoteSummary',
  INTL_TRANSFER_RESPONSE = 'intlTransferResponse',
  MANAGE_USER = 'manageUser',
  MANAGE_USER_EDIT = 'manageUserEdit',
  ADD_EMPLOYEE = 'addEmployee',
  EMPLOYEE_DETAILS = 'employeeDetails',
  BULK_PAYMENTS = 'bulkPayments',
  PROFILE_BANK_STATEMENT = 'profileBankStatement',
  EDIT_PROFILE_DETAILS = 'editProfileDetails',
  CURRENCY_EXCHANGE = 'currencyExchange',
  EDIT_BENEFICIARY = 'editBeneficiary',
  ADD_BENEFICIARY = 'addBeneficiary',
  LOCALE_VARIABLES = 'localeVariables',
  SEPA_PAYMENT = 'sepaPayment',
  SEPA_PAYMENT_RAIL_FLAG = 'sepaPaymentRailFlag',
  BIOMETRICS_AUTHENTICATION_TOGGLE = 'biometricsAuthenticationToggle',
  BENEFICIARY_PAYMENT_CURRENCY_SELECTION = 'beneficiaryPaymentCurrencySelection',
  BENEFICIARY_FORM = 'beneficiaryForm',
  COMPANIES_HOUSE_SEARCH = 'companiesHouseSearch',
  BUSINESS_ONBOARDING_FLOW = 'businessOnboardingFlow',
  COMPANIES_HOUSE_SELECTED_OFFICER = 'companiesHouseSelectedOfficer',
}
